/* @flow */

type TOptions = {
	symbol?: string,
	word?: string,
	prefix?: string,
	suffix?: string,
	lte?: { text: string, value: number },
	gte?: { text: string, value: number },
};

export const getQuarter = (date: Date): number => {
	const month = date.getMonth() + 1;
	return Math.ceil(month / 3);
};

export const getTodayDeadline = () => {
	const curr = new Date();
	return curr.getFullYear() * 100 + getQuarter(curr);
};

export const isDeadlinePast = (deadline: number): boolean => {
	const now = new Date();
	const today = new Date(now.setHours(0, 0, 0, 0));
	const todayYear = today.getFullYear();
	const todayQuarter = getQuarter(today);
	const deadlineYear = parseInt(deadline / 100, 10);
	const deadlineQuarter = deadline % 10;

	if (deadlineYear < todayYear) return true;
	if (deadlineYear > todayYear) return false;
	return deadlineQuarter < todayQuarter;
};

/**
 * Форматирование дэдлайна
 * @param {number} deadline
 * @param {Object} [options]
 * @param {'roman' | 'arabic'} [options.symbol]
 * @param {'short' | 'full' | 'genitive'} [options.word]
 * @returns {string}
 *
 * @example
 * // returns 'IV кв. 2019'
 * formatDeadline(201904)
 *
 * @example
 * // returns '4 квартала 2019'
 * formatDeadline(201904, { symbol: 'arabic', word: 'genitive' })
 */

export const formatDeadline = (deadline: number, options: TOptions = {}) => {
	const {
		symbol = 'roman',
		word = 'short',
		prefix = '',
		suffix = '',
		lte = { text: 'Сдано', value: 0 },
		gte = { text: 'Не важно', value: 300000 },
	} = options;

	const QUARTER_SYMBOL = {
		0: {
			roman: 'I',
			arabic: '1',
		},
		1: {
			roman: 'I',
			arabic: '1',
		},
		2: {
			roman: 'II',
			arabic: '2',
		},
		3: {
			roman: 'III',
			arabic: '3',
		},
		4: {
			roman: 'IV',
			arabic: '4',
		},
	};

	const QUARTER_WORD = {
		short: 'кв.',
		full: 'квартал',
		genitive: 'квартала',
	};

	if (deadline === null) return `—`;

	if (deadline === 0) return lte.text;

	if (deadline >= gte.value) return gte.text;

	// eslint-disable-next-line no-bitwise
	return `${prefix}${QUARTER_SYMBOL[deadline % 10][symbol]} ${QUARTER_WORD[word]} ${~~(deadline / 100)}${suffix}`;
};
